export const MAX_GALLERY_IMAGES = parseInt(
  import.meta.env.VITE_GALLERY_MAX_IMAGES || '10',
  10
);

export const MAX_ROOM_IMAGES = parseInt(
  import.meta.env.VITE_ROOM_MAX_IMAGES || '10',
  10
);

export const DEFAULT_ROOM_IMAGE = '/images/room-placeholder.svg';

// TODO: hardcoded until the backend exposes a per-property currency field — matches the
// hardcoded "฿" symbol already used throughout the booking UI (single-currency system today).
export const DEFAULT_CURRENCY = 'THB';
